import type { SVGProps } from 'react';
const resCheckmarkTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M2.52332 10.2243C3.10911 9.63856 4.05886 9.63856 4.64464 10.2243L9.11374 14.6934L18.7966 5.01063C19.3557 4.45147 20.2465 4.42605 20.8358 4.93438L20.9179 5.01063C21.5037 5.59642 21.5037 6.54616 20.9179 7.13195L10.4396 17.6103C9.70734 18.3425 8.52016 18.3425 7.78793 17.6103L2.52332 12.3457C1.93754 11.7599 1.93754 10.8101 2.52332 10.2243Z"
      fill={props.color ?? '#144761'}
      fillRule="evenodd"
    />
  </svg>
);
export default resCheckmarkTemplateOutline;
